import { ChevronRight, LayoutGrid, Lock, MessageCircle, Printer, Receipt, Store, UserPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../assets/scss/pages/SettingsPage.module.scss';

const ZALO_PHONE = '0813866136';

const SETTINGS_ITEMS = [
    {
        to: '/admin/settings/shop',
        icon: <Store />,
        iconClass: 'cardIconOrange',
        title: 'Thông tin cửa hàng',
        desc: 'Xem và cập nhật tên cửa hàng, chủ cửa hàng, số điện thoại, địa chỉ...',
    },
    {
        to: '/admin/settings/invoice',
        icon: <Receipt />,
        iconClass: 'cardIconBlue',
        title: 'Cài đặt hoá đơn',
        desc: 'Cấu hình nội dung hiển thị khi in hoá đơn: thông tin cửa hàng, SĐT khách, điểm tích lũy...',
    },
    {
        to: '/admin/settings/printer',
        icon: <Printer />,
        iconClass: 'cardIconGreen',
        title: 'Máy in hoá đơn',
        desc: 'Cấu hình máy in nhiệt: địa chỉ IP, cổng kết nối, khổ giấy, độ đậm in...',
    },
    {
        to: '/admin/settings/service-tabs',
        icon: <LayoutGrid />,
        iconClass: 'cardIconOrange',
        title: 'Cấu hình danh mục',
        desc: 'Bật/tắt và sắp xếp thứ tự các tab Sản phẩm, Dịch vụ, Combo, Gói dịch vụ theo ngành của bạn...',
    },
    {
        to: '/admin/settings/change-password',
        icon: <Lock />,
        iconClass: 'cardIconBlue',
        title: 'Đổi mật khẩu',
        desc: 'Cập nhật mật khẩu đăng nhập tài khoản của bạn...',
    },
];

export default function SettingsIndex() {
    const navigate = useNavigate();

    const handleOpenCheckin = () => {
        if (window.confirm('Bạn có chắc chắn muốn chuyển qua màn hình Checkin?')) {
            navigate('/checkin');
        }
    };

    const handleOpenZalo = () => {
        window.open(`https://zalo.me/${ZALO_PHONE}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <div>
                    <h1 className={styles.title}>Cài đặt</h1>
                    <div className={styles.subtitle}>Cấu hình hệ thống và thiết bị</div>
                </div>
            </div>

            <div className={styles.grid}>
                {SETTINGS_ITEMS.map((item) => (
                    <div
                        key={item.to}
                        className={styles.card}
                        onClick={() => navigate(item.to)}
                    >
                        <div className={`${styles.cardIcon} ${styles[item.iconClass]}`}>
                            {item.icon}
                        </div>
                        <div className={styles.cardBody}>
                            <div className={styles.cardTitle}>{item.title}</div>
                            <div className={styles.cardDesc}>{item.desc}</div>
                        </div>
                        <ChevronRight size={18} className={styles.cardArrow} />
                    </div>
                ))}

                {/* Màn check-in cho khách tự nhập SĐT */}
                <div className={styles.card} onClick={handleOpenCheckin}>
                    <div className={`${styles.cardIcon} ${styles.cardIconGreen}`}>
                        <UserPlus />
                    </div>
                    <div className={styles.cardBody}>
                        <div className={styles.cardTitle}>Chuyển qua màn hình Checkin</div>
                        <div className={styles.cardDesc}>Mở màn hình để khách tự nhập số điện thoại check-in, đăng ký và xem điểm tích lũy...</div>
                    </div>
                    <ChevronRight size={18} className={styles.cardArrow} />
                </div>

                {/* Zalo CSKH card — mở tab mới */}
                <div className={styles.card} onClick={handleOpenZalo}>
                    <div className={`${styles.cardIcon} ${styles.cardIconZalo}`}>
                        <MessageCircle />
                    </div>
                    <div className={styles.cardBody}>
                        <div className={styles.cardTitle}>Chat Zalo CSKH Navo Sổ Tiệm</div>
                        <div className={styles.cardDesc}>Liên hệ hỗ trợ trực tiếp qua Zalo ({ZALO_PHONE})...</div>
                    </div>
                    <ChevronRight size={18} className={styles.cardArrow} />
                </div>
            </div>
        </div>
    );
}
